var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarHalf = function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#starHalf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M12 0a1.33 1.33 0 0 0-1.192.75L8.125 6.263l-5.983.883a1.33 1.33 0 0 0-1.071.904A1.34 1.34 0 0 0 1.4 9.412l4.342 4.296-1.025 6.071a1.337 1.337 0 0 0 1.946 1.4L12 18.325zm5.913 21.333a1 1 0 0 0 .133 0z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M5.963 21.333h.133a1 1 0 0 1-.133 0M12 18.325V0h.004c.508 0 .975.292 1.2.75l2.68 5.513 5.983.883c.5.075.916.425 1.07.904a1.34 1.34 0 0 1-.329 1.362l-4.337 4.296 1.025 6.071a1.337 1.337 0 0 1-1.946 1.4l-5.346-2.854-.004.004z",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "starHalf_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v21.333H0z"
  })))));
};
export default SvgStarHalf;